export default function (props: any) {
    return (
        <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="web" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MH200-Mobile" transform="translate(-304.000000, -6256.000000)">
                    <g id="重播icon" transform="translate(304.000000, 6256.000000)">
                        <circle id="椭圆形" fillOpacity="0.421403792" fill="#FFFFFF" cx="18" cy="18" r="18"></circle>
                        <path
                            d="M17.9093682,12.8871459 C14.4507903,12.8871459 11.6470588,15.6908773 11.6470588,19.1494553 C11.6470588,22.6080333 14.4507903,25.4117647 17.9093682,25.4117647 C21.3679462,25.4117647 24.1716777,22.6080333 24.1716777,19.1494553 C24.1716777,17.6609218 23.6523296,16.2936885 22.7849489,15.2190708"
                            id="路径"
                            stroke="#1A1A1A"
                            strokeWidth="2"
                            strokeLinecap="round"
                        ></path>
                        <polyline
                            id="路径"
                            stroke="#1A1A1A"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            transform="translate(16.288456, 13.115123) rotate(-48.000000) translate(-16.288456, -13.115123) "
                            points="18.0776877 11.3258914 18.0776877 14.9043539 14.4992251 14.9043539"
                        ></polyline>
                    </g>
                </g>
            </g>
        </svg>
    );
}
